export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/italian.ff8223b.svg";